/* STERPA v2 — Theme JS */
document.addEventListener('DOMContentLoaded', () => {

  // Mobile nav
  const burger = document.querySelector('.burger');
  const nav    = document.querySelector('.nav');
  if (burger && nav) {
    burger.addEventListener('click', () => {
      const open = nav.classList.toggle('nav--open');
      if (open) {
        Object.assign(nav.style, { display:'flex', flexDirection:'column', position:'absolute', top:'60px', left:'0', right:'0', background:'rgba(247,244,238,.97)', borderBottom:'1px solid var(--border)', padding:'1.5rem', zIndex:'99', gap:'1.25rem' });
      } else {
        nav.style.display = '';
      }
    });
  }

  // Qty selectors
  // (cart page quantities are handled by sections/main-cart.liquid, so skipped here)
  document.querySelectorAll('.qty').forEach(el => {
    if (el.closest('.cart-item')) return;
    const v = el.querySelector('.qty__val');
    el.querySelector('.qty__btn--minus')?.addEventListener('click', () => { const n = parseInt(v.textContent); if (n > 1) v.textContent = n - 1; });
    el.querySelector('.qty__btn--plus')?.addEventListener('click',  () => { v.textContent = parseInt(v.textContent) + 1; });
  });

  // Option toggles — also keeps the selected variant id in sync
  const variantData = document.getElementById('product-variants');
  let variants = [];
  try { variants = variantData ? JSON.parse(variantData.textContent) : []; } catch (err) { variants = []; }

  const syncVariant = () => {
    if (!variants.length) return;
    const chosen = Array.from(document.querySelectorAll('.opt-btns')).map(g => g.querySelector('.opt-btn.active')?.dataset.value);
    const match = variants.find(v => v.options.every((o, i) => o === chosen[i]));
    if (!match) return;
    const form = document.querySelector('.pi__add')?.closest('form');
    const idInput = form?.querySelector('[name="id"]');
    if (idInput) idInput.value = match.id;
    document.querySelectorAll('[data-product-price]').forEach(el => { el.textContent = match.price; });
    const addBtn = form?.querySelector('.btn-add-to-cart');
    if (addBtn) addBtn.disabled = !match.available && addBtn.dataset.soldOutDisable === 'true';
  };

  document.querySelectorAll('.opt-btns').forEach(g => {
    g.querySelectorAll('.opt-btn').forEach(b => {
      b.addEventListener('click', () => {
        g.querySelectorAll('.opt-btn').forEach(x => x.classList.remove('active'));
        b.classList.add('active');
        syncVariant();
      });
    });
  });

  // Gallery — thumbnails, prev/next arrows, swipe
  document.querySelectorAll('.product-gallery').forEach(gal => {
    const main   = gal.querySelector('.gal__main img');
    const thumbs = Array.from(gal.querySelectorAll('.gal__thumb'));
    if (!main || !thumbs.length) return;
    let current = Math.max(0, thumbs.findIndex(t => t.classList.contains('active')));

    const show = (i) => {
      current = (i + thumbs.length) % thumbs.length;
      const t = thumbs[current];
      const img = t.querySelector('img');
      main.src = t.dataset.full || img?.src;
      main.alt = img?.alt || '';
      thumbs.forEach(x => x.classList.remove('active'));
      t.classList.add('active');
    };

    thumbs.forEach((t, i) => {
      t.addEventListener('click', () => show(i));
      t.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); show(i); } });
    });
    gal.querySelector('.gal__arrow--prev')?.addEventListener('click', () => show(current - 1));
    gal.querySelector('.gal__arrow--next')?.addEventListener('click', () => show(current + 1));

    let startX = null;
    const stage = gal.querySelector('.gal__main');
    stage.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) > 40) show(dx < 0 ? current + 1 : current - 1);
    });
  });

  // Add to Cart — real AJAX
  const badge = document.querySelector('.cart-count');
  document.querySelectorAll('.btn-add-to-cart').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const form = btn.closest('form');
      const variantId = form?.querySelector('[name="id"]')?.value;
      const qty = parseInt(form?.querySelector('.qty__val')?.textContent || '1');
      if (!variantId) return;

      btn.disabled = true;
      const orig = btn.innerHTML;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
      .then(r => r.json())
      .then(() => fetch('/cart.js').then(r => r.json()))
      .then(cart => {
        if (badge) badge.textContent = cart.item_count;
        btn.textContent = 'Added ✓';
        setTimeout(() => { btn.innerHTML = orig; btn.disabled = false; }, 1400);
      })
      .catch(() => {
        btn.innerHTML = orig;
        btn.disabled = false;
      });
    });
  });

  // Scroll reveal
  const items = Array.from(document.querySelectorAll('[data-r]'));
  if (items.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach((e, i) => {
        if (e.isIntersecting) {
          setTimeout(() => {
            e.target.style.opacity = '1';
            e.target.style.transform = 'none';
          }, (e.target.dataset.ri || 0) * 70);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    items.forEach((el, i) => {
      el.style.cssText += 'opacity:0;transform:translateY(16px);transition:opacity .5s ease,transform .5s ease;';
      el.dataset.ri = i % 4;
      io.observe(el);
    });
  }

});
